// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3bTQI","bigColWidth":"Table_bigColWidth__1aiC9","biggerColWidth":"Table_biggerColWidth__202rU","row":"Table_row__A1yqa","col":"Table_col__2i0bm"};